import { useGetAuthenticatedUser, useGetOrderSelector, useGetSamplePoolSelector } from 'Flux/Selector/index.js'
import { useEffect } from 'react'
import { useParams, useSearchParams } from 'react-router-dom'
import { OrderDetailView } from './OrderDetailView.js'
import Actions from 'Flux/index.js'
import { orderSlice } from 'Flux/Slice/Order/OrderSlice.js'
import { useDispatch } from 'react-redux'
import { authenticationSlice } from '../../../Flux/Slice/Authentication/AuthenticationSlice.js'
import { useGetOtuCountSelector } from '../../../Flux/Selector/Order/GetOtuCount/GetOtuCountSelector.js'
import { exampleStates } from '../../HelpTour/tourOrderStates.js'

export function OrderParamLoaderView() {
  const { id } = useParams()
  const [searchParams] = useSearchParams()

  const token = searchParams.get('token')

  const dispatch = useDispatch()
  const order = useGetOrderSelector()
  const samplePools = useGetSamplePoolSelector()
  const otuCount = useGetOtuCountSelector()
  const user = useGetAuthenticatedUser()

  if (!id) {
    return 'no order id specified'
  }

  useEffect(() => {
    console.log('in Order Param Loader!', id)
    dispatch(Actions[orderSlice.name].reset())
    dispatch(Actions[authenticationSlice.name].updateUserIfPresent())

    if (id && exampleStates[id]) {
      return
    }

    if (id) {
      if (token) {
        dispatch(Actions[orderSlice.name].getPublicOrderRequest({ orderId: id, token }))
      } else {
        dispatch(Actions[orderSlice.name].getOrderRequest({ orderId: id }))
      }
    }
  }, [id, token])

  // Keyed on the signed-in user, not the share token: a member opening a share link still sees the notices.
  const userId = user?.id
  useEffect(() => {
    if (userId && id && !exampleStates[id]) {
      dispatch(Actions[orderSlice.name].fetchOrderNotices({ orderId: id }))
    }
  }, [id, userId, dispatch])

  useEffect(() => {
    if (user && id && exampleStates[id]) {
      dispatch(Actions[orderSlice.name].applyState(exampleStates[id]({ user: user })))
    }
  }, [user])

  useEffect(() => {
    if (id && exampleStates[id]) {
      return
    }

    /* avoid loading things which cannot be present for deleted or draft orders */
    if (order && order !== 'LOADING' && !order.deletedAt && !token) {
      if (order.type !== 'draft') {
        dispatch(Actions[orderSlice.name].getOtuCountRequest({ orderId: id }))
        dispatch(Actions[orderSlice.name].fetchIntermediatesStatus({ orderId: id }))
        if (order.orderDone) {
          dispatch(Actions[orderSlice.name].fetchReprocessingGrant({ orderId: id }))
          dispatch(Actions[orderSlice.name].fetchOtuProcessingData({ orderId: id }))
        }
      }
      dispatch(Actions[orderSlice.name].getAllDatasetRequest({ orderId: id }))
      dispatch(Actions[orderSlice.name].fetchPipelineState({ orderId: id }))
      dispatch(Actions[orderSlice.name].getSampleMetaDatasRequest({ orderId: id }))
    }
  }, [order])

  if (order === 'LOADING') {
    return (
      <div className="flex items-center justify-center min-h-[50vh] text-blue-800">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={1.5}
          stroke="currentColor"
          className="w-12 h-12 sm:w-16 sm:h-16 md:w-24 md:h-24 animate-spin"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0 3.181 3.183a8.25 8.25 0 0 0 13.803-3.7M4.031 9.865a8.25 8.25 0 0 1 13.803-3.7l3.181 3.182m0-4.991v4.99"
          />
        </svg>
      </div>
    )
  }

  if (!id || !order) {
    return (
      <div className="flex items-center justify-center min-h-[50vh] text-red-800">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={1.5}
          stroke="currentColor"
          className="w-12 h-12 sm:w-16 sm:h-16 md:w-24 md:h-24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z"
          />
        </svg>
      </div>
    )
  }
  return <OrderDetailView order={order} samplePools={samplePools} tokenChecksum={token || undefined} otuCount={otuCount || undefined} />
}
